import { useJwtPublic as servicePublic } from './service'

export default {
  getAgencyConfig(websiteUrl) {
    return servicePublic.get('/public/agency-config', { websiteUrl })
  },
}
